module.exports = __webpack_public_path__ + "static/img/6.333e618.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/6.png
// module id = IpgA
// module chunks = 0